import { Container, Row, Col } from "react-bootstrap";
import Tony from "../../images/Tony.png";

const TonyBio = () => {
  return (
    <div>
      <Container>
        <Row className="my-5">
          <Col xs={12}>
            <h2>TONY COSENTINO</h2>
          </Col>
        </Row>
        <Row className="mb-5">
          <Col xs={12} md={6}>
            <img src={Tony} className="img-fluid mb-5" alt="Tony Cosentino" />
          </Col>
          <Col xs={12} md={6} className="text-start bioText">
            <p>
              Hailing from Central Ohio, Tony Cosentino knows a thing or two
              about working hard. A Gutter Installation Professional by day and
              an aspiring racecar driver in his off time, you'll be hard pressed
              to find Tony not working.
            </p>
            <p>
              Originally beginning his driving career in Karts, Tony quickly
              progressed through disciplines into Dirt Sprint cars. From there,
              he made the transition to Asphalt Late Models in 2014 further
              rounding out his driving skill set.
            </p>
            <p>
              With his 2021 venture into the ARCA Menard's Series platform as a
              driver, Tony has worked in every aspect of the racing business.
            </p>
            <p>
              He has served as a Pit Crew Member for NASCAR Cup teams, as a Crew
              Chief in ARCA, a Spotter in all touring series, and has even been
              a team owner in the Carolina Late Model Series. With experience in
              all these different roles and at different levels of Racing, Tony
              has a unique understanding of what it takes to be Successful.
            </p>
            <p>
              As a Driver, Tony has been Active in the ARCA Menard's platform in
              some form since 2019. He made his first career starts in what was
              then known as the K&N Pro Series West at the end of the 2019
              season before sitting out 2020.
            </p>
            <p>
              For 2021, Tony spent time with Fast Track Racing as a Driver, Crew
              Chief and Mechanic. In several races he began driving one car,
              before retiring and serving as the crew chief in another.
            </p>
            <p>
              Despite running some shortened races to fulfill his Crew Chief
              obligations, or a mechanical failure, his showings when he ran
              full races were impressive!
            </p>
            <p>
              Almost always out Qualifying his teammates, he proved he has what
              it takes to put a fast car on track.
            </p>
            <p>
              Most importantly, he earned his first top 10 finish of his career
              in a race at Winchester. 2022 proves to be even more fruitful for
              Tony and his marketing partners, as he is projected to Start even
              more races for the ARCA Menard's Season.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TonyBio;
